// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStrengthMeter-Suggestions_cls1__Qoywi","cls2":"VeloStrengthMeter-Suggestions_cls2__El80R VeloStrengthMeter-Suggestions_cls1__Qoywi"};